import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from 'sonner';
import { Category } from '@/types';
import { Label } from '@/components/ui/label';

interface EditCategoryDialogProps {
  category: Category | null;
  categories: Category[];
  onEditCategory: (categoryId: string, newName: string, newParentId: string | null, newType: 'Afdracht' | 'Geen afdracht') => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const EditCategoryDialog = ({
  category,
  onEditCategory,
  open,
  onOpenChange,
}: EditCategoryDialogProps) => {
  const [categoryName, setCategoryName] = useState('');
  const [categoryType, setCategoryType] = useState<'Afdracht' | 'Geen afdracht'>('Geen afdracht');

  useEffect(() => {
    if (category) {
      setCategoryName(category.name);
      setCategoryType(category.type);
    }
  }, [category]);

  const handleEditCategory = () => {
    if (!category) return;
    
    if (!categoryName.trim()) {
      toast.error('Please enter a category name');
      return;
    }
    
    // Keep the same parent ID when editing and include the type
    onEditCategory(category.id, categoryName, category.parentId || null, categoryType);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Category</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-4">
          <div className="space-y-2">
            <Label htmlFor="categoryName">Category Name</Label>
            <Input
              id="categoryName"
              placeholder="Category Name"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="categoryType">Category Type</Label>
            <select
              id="categoryType"
              className="w-full border rounded-md p-2 bg-white dark:bg-gray-950"
              value={categoryType}
              onChange={(e) => setCategoryType(e.target.value as 'Afdracht' | 'Geen afdracht')}
            >
              <option value="Afdracht">Afdracht</option>
              <option value="Geen afdracht">Geen afdracht</option>
            </select>
          </div>
          <Button 
            onClick={handleEditCategory}
            className="w-full bg-[#ff6d00] hover:bg-[#ff6d00]/90 text-white"
          >
            Save Changes
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
